import IInitiativeSubmissionData from 'types/IInitiativeSubmissionData'
import { IUpdateInitiativeAnswer } from '../Interfaces'

export const SET_INITIATIVE_DATA = 'initiativeManagementComponent.setInitiativeData'
export const SET_IS_LOADING_INITIATIVE = 'initiativeManagementComponent.setIsLoadingInitiative'

export const SET_GRADUATE_GPA_VALUE = 'initiativeManagementComponent.setGraduateGpaValue'
export const SET_DOES_NOT_APPLY_GRADUATE_GPA = 'initiativeManagementComponent.setDoesNotApplyGraduateGpa'

export const SET_UNDERGRADUATE_GPA_VALUE = 'initiativeManagementComponent.setUndergraduateGpaValue'
export const SET_DOES_NOT_APPLY_UNDERGRADUATE_GPA = 'initiativeManagementComponent.setDoesNotApplyUndergraduateGpa'

export const SET_QUESTION_ANSWER = 'initiativeManagementComponent.setQuestionAnswer'
export const SET_IS_SUBMITTING_INITIATIVE = 'initiativeManagementComponent.setIsSubmittingInitiative'
export const SET_IS_WITHDRAWING = 'initiativeManagementComponent.setIsWithdrawing'
export const RESET = 'initiativeManagementComponent.reset'

export function setInitiativeData(initiativeData: IInitiativeSubmissionData, answers: IUpdateInitiativeAnswer) {
  return {
    type: SET_INITIATIVE_DATA,
    payload: {
      initiativeData,
      answers
    }
  } as const
}

export function setIsLoadingInitiative(payload: boolean) {
  return {
    type: SET_IS_LOADING_INITIATIVE,
    payload
  } as const
}

export function setGraduateGpaValue(payload: number) {
  return {
    type: SET_GRADUATE_GPA_VALUE,
    payload
  } as const
}

export function setDoesNotApplyGraduateGpa(payload: boolean) {
  return {
    type: SET_DOES_NOT_APPLY_GRADUATE_GPA,
    payload
  } as const
}

export function setUndergraduateGpaValue(payload: number) {
  return {
    type: SET_UNDERGRADUATE_GPA_VALUE,
    payload
  } as const
}

export function setDoesNotApplyUndergraduateGpa(payload: boolean) {
  return {
    type: SET_DOES_NOT_APPLY_UNDERGRADUATE_GPA,
    payload
  } as const
}

export function setQuestionAnswer(questionId: number, answer: string) {
  return {
    type: SET_QUESTION_ANSWER,
    payload: {
      [questionId]: { answer }
    }
  } as const
}

export function setQuestionChoice(questionId: number, choices: number[]) {
  return {
    type: SET_QUESTION_ANSWER,
    payload: {
      [questionId]: { choices }
    }
  } as const
}

export function setIsSubmittingInitiative(payload: boolean) {
  return {
    type: SET_IS_SUBMITTING_INITIATIVE,
    payload
  } as const
}

export function setIsWithdrawing(payload: boolean) {
  return {
    type: SET_IS_WITHDRAWING,
    payload
  }
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type InitiativeManagementAction = ReturnType<
  | typeof setInitiativeData
  | typeof setIsLoadingInitiative
  | typeof setGraduateGpaValue
  | typeof setUndergraduateGpaValue
  | typeof setQuestionAnswer
  | typeof setQuestionChoice
  | typeof setIsSubmittingInitiative
  | typeof setIsWithdrawing
  | typeof reset
  | typeof setDoesNotApplyGraduateGpa
  | typeof setDoesNotApplyUndergraduateGpa
>
